import { UseMutationOptions } from '@tanstack/react-query';

import { CommunicationType } from 'domains/content/types';
import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

export type CreateSmsInput = {
    applicationsAccess: string;
    name: string;
    communicationType: CommunicationType;
    content: string;
    parentFolderId?: number;
    contentMultilingual?: Record<string, string>;
    autoResponsesMultilingual?: Record<string, any[]>;
};

const useCreateSms = (mutateOptions: UseMutationOptions<unknown, Error, CreateSmsInput>) =>
    useMutation<CreateSmsInput>(MutationKeys.CREATE_SMS, CuredApiPaths.SMS, mutateOptions);

export default useCreateSms;
